import { Injectable } from '@angular/core';
import { DiscussionsService } from '../discussions.service';
import { RxEmitter } from 'common/rxjs/rx-emitter';
import { WorkItemListenerService } from 'common/workitems/workitem-listener.service';
import { MessageGroupService } from 'shared/services/message-group/message-group.service';
import { WorkItemTypes } from 'common/workitems/constants/workitem-types';
import { DiscussionOperatorTypes, DiscussionsMessagesTypes } from '../discussion-properties';
import { DiscussionStateMessages } from '../discussion-request-states';
import { TranslateService } from '@ngx-translate/core';
import { MessageBusEvents } from 'common/common/constants/message-bus-events';
import Moment from 'moment';
import { DiscussionMessageGroupModel } from 'shared/services/message-group/message-group.model';

@Injectable()
export class DiscussionsMessagesService {
  public discussionsMessages = [];
  public moment;

  constructor(private _rxEmitter: RxEmitter,
              private _workItemListenerService: WorkItemListenerService,
              private _discussionsService: DiscussionsService,
              private _messageGroupService: MessageGroupService,
              private _translateService: TranslateService) {
    this.moment = Moment;
  }

  public getMessages(workItemId) {
    return this.discussionsMessages[workItemId];
  }

  public initSubscription(workItemId) {
    if (!this.discussionsMessages[workItemId]) {
      this.discussionsMessages[workItemId] = [];
    }
    return this._workItemListenerService.createObservableForWorkItemDiscussionMessages(workItemId).subscribe(
      messages => this._itemInserted(workItemId, messages)
    );
  }

  public formatSystemMessage(message) {
    const timestamp = message.Created;
    switch (message.DiscussionMessage) {
      case DiscussionStateMessages.ACCEPTED:
        return this._translateService.instant('discussions-messages.accepted', { operatorName: message.OperatorName, timestamp: this.formatTimestamp(timestamp) });
      case DiscussionStateMessages.INITIATED:
        return this._translateService.instant('discussions-messages.initiated', { operatorName: message.OperatorName, timestamp: this.formatInitTimestamp(timestamp) });
      case DiscussionStateMessages.INITIATED_ACD:
        return this._translateService.instant('discussions-messages.initiatedAcd', { departmentName: message.DepartmentName });
      case DiscussionStateMessages.CANCELLED:
        return this._translateService.instant('discussions-messages.cancelled', { operatorName: message.OperatorName, timestamp: this.formatTimestamp(timestamp) });
      case DiscussionStateMessages.ENDED:
        return this._translateService.instant('discussions-messages.ended', { operatorName: message.OperatorName, timestamp: this.formatTimestamp(timestamp) });
    }
  }

  public formatTimestamp(timestamp) {
    return this.moment(timestamp).format('LTS');
  }

  public formatInitTimestamp(timestamp) {
    return this.moment(timestamp).format('ddd, MMM Do, h:mm A');
  }

  public getOperatorTypeKey(operatorType) {
    let operatorTypeKey;
    if (operatorType === DiscussionOperatorTypes.HELPER) {
      operatorTypeKey = DiscussionOperatorTypes.HELPER;
    } else {
      operatorTypeKey = DiscussionOperatorTypes.OPERATOR;
    }
    return operatorTypeKey;
  }

  private _itemInserted(id: string, item: DiscussionMessageGroupModel[]): void {
    if (!item || !item.length) {
      return;
    }
    this.discussionsMessages[id] = this._messageGroupService.addNewMessagesToGroups(this.discussionsMessages[id], item, WorkItemTypes.DISCUSSION);
    this._rxEmitter.send(MessageBusEvents.DiscussionMessageInserted + `-${id}`, item);
    const lastMessage = item[item.length - 1];
    if (lastMessage.MessageType === DiscussionsMessagesTypes.SYSTEM) {
      this._discussionsService.changeRequestStatus(lastMessage, id);
    }
  }
}
